// This file was once generated when you created this area
// but you can edit it freely

const baseRoute = '/vehicles'

// In order to work with updated version router v6, path was added for nested routes with a relative path.
export const VehicleAreaRoutes = {
  route: baseRoute,
  Details: {
    route: `${baseRoute}/:vehicleId/details`,
    path: 'details',
  },
  DetailsBase: {
    route: `${baseRoute}/:vehicleId/*`,
    path: ':vehicleId/*',
  },
  Emergency: {
    route: `${baseRoute}/:vehicleId/emergency`,
    path: 'emergency',
  },
  Hardware: {
    route: `${baseRoute}/:vehicleId/hardware`,
  },
  History: {
    route: `${baseRoute}/:vehicleId/history`,
    path: 'history',
  },
  HubView: {
    route: `${baseRoute}/hub-view`,
    path: 'hub-view',
  },
  RideChecks: {
    route: `${baseRoute}/ride-checks`,
    path: 'ride-checks',
  },
  RideChecksView: {
    route: `${baseRoute}/ride-checks/:reportId/view`,
    path: 'ride-checks/:reportId/view/*',
  },
  RideChecksNotFound: {
    route: `${baseRoute}/ride-checks/not-found`,
    path: 'ride-checks/not-found',
  },
  Interactions: {
    route: `${baseRoute}/:vehicleId/interactions`,
    path: 'interactions',
  },
  Table: {
    route: baseRoute,
  },
  Testing: {
    route: `${baseRoute}/:vehicleId/testing`,
    path: 'testing',
  },
  Overview: {
    route: `${baseRoute}/:vehicleId/overview`,
    path: 'overview',
  },
  NewOverview: {
    route: `${baseRoute}/:vehicleId/new-overview`,
    path: 'new-overview',
  },
  VehicleLists: {
    route: `${baseRoute}/lists`,
    path: 'lists',
  },
  StateOverview: {
    route: `${baseRoute}/state-overview`,
    path: 'state-overview',
  },
}
